import { ApiQueryName } from "@/models/api"
import { User } from "@/models/user"
import type { SpraypaintQueryOptions, UseApiOptions } from "@/services/types"
import type { HttpError } from "@/utils/api"
import { toHttpError } from "@/utils/api"
import { useQuery } from "@tanstack/react-query"

import { useRenameQueryResult } from "../utils"
import { createQueryKey } from "../utils/createQueryKey"

const placeholderUsers: User[] = [
  new User({ email: "user1@placeholder.com", id: "1", name: "User 1" }),
  new User({ email: "user2@placeholder.com", id: "2", name: "User 2" }),
  new User({ email: "user3@placeholder.com", id: "3", name: "User 3" }),
]

const getUsers = async ({
  page,
  pageSize,
  sort,
  where,
}: SpraypaintQueryOptions = {}): Promise<User[]> => {
  try {
    const response = await User.where(where ?? {})
      .order(sort ?? {})
      .page(page ?? 1)
      .per(pageSize ?? 500)
      .all()

    return response.data as User[]
  } catch (error: unknown) {
    throw toHttpError(error)
  }
}

export const useUsers = (
  options: UseApiOptions<SpraypaintQueryOptions, User[], HttpError> = {}
) => {
  const { apiQueryOptions = {}, queryOptions = {} } = options

  const queryKey = createQueryKey(ApiQueryName.Users, "getMany", null, {
    apiQueryOptions,
  })

  const queryResult = useQuery({
    placeholderData: placeholderUsers,
    ...queryOptions,
    queryFn: async () => getUsers(apiQueryOptions),
    queryKey,
  })

  return useRenameQueryResult(queryResult, ApiQueryName.Users)
}
